export default "__VITE_ASSET__DUAkrYfO__"